import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import Sidebar from '../../comman_page/Sidebar';
import { HeaderDashboard } from '../../comman_page/HeaderDashboard';
import { Footer } from '../../../../../public/containers/footer/Footer';
import { useLocation } from 'react-router-dom';
import { SharedButton } from '../../../../../sharedComponents/Button';


export const AttendanceChart = () => {
  const location = useLocation();
  console.log("---------->", location.state);
  // const options = {
  //   scales: {
  //     x: {
  //       stacked: true,
  //     },
  //     y: {
  //       stacked: true,
  //     },
  //   },
  //   plugins: {
  //     legend: {
  //       position: 'right',
  //     },
  //     title: {
  //       display: true,
  //       text: 'Grouped bar chart',
  //     },
  //   },
  // };

  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Canceled',
        data: [5, 13, 20, 20, 25, 3],
        backgroundColor: 'orange',
      },
      {
        label: 'No Show',
        data: [15, 20, 25, 40, 30, 14],
        backgroundColor: 'red',
      },
      {
        label: 'Attended',
        data: [8, 10, 15, 25, 25, 35],
        backgroundColor: 'blue',
      },
    ],
  };

  return (
    <>
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>
            <Sidebar />
            <Col>
              <HeaderDashboard />
              <div className="RightSide">
                <div className="innerContent">
                  <section className="ClassAttendance">
                    <Container>
                      <Row className='mb-3 mt-3' >
                        <Col className='d-flex' style={{justifyContent: 'space-between'}}>
                        <h4>Attendance by Status</h4>
                          <SharedButton
                            title={"Back"}
                            className={"backBtn"}
                            type={"button"}
                            onClick={() => {
                              window.history.back();
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-5' style={{ maxWidth: "64rem" }}>
                        <Col>
                          <Bar
                           height={300} // Set height here
                           width={600} 
                           options={{
                            maintainAspectRatio: false // Set to false if you want to control the chart dimensions explicitly
                          }}
                          // options={options} 
                          data={data} />
                        </Col>
                      </Row>
                       <Row className='mb-3 mt-3' >
                        <Col className='d-flex' style={{justifyContent: 'space-between'}}>
                        <h4>Instructor</h4>
                        <h4>Class</h4>
                        <h4>Date Range</h4>
                        </Col>
                      </Row>
                    </Container>
                  </section>
                </div>
                <Footer />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>

  );
};
